import React from "react";
import { Route, Switch } from "react-router-dom";
import { CheckPermission } from "util/CheckPermission";
import asyncComponent from "util/asyncComponent";
const Role = ({ match }) => (
    <Switch>
        {CheckPermission("admin") && <Route exact path={`${match.url}/list`} component={asyncComponent(() => import('../../components/Role/ListRole'))} />}


    </Switch>
)

export default Role;